import Ribbon from "../../components/ribbon/ribbon";
import ReviewerSidebar from "../../components/leadReviewer/reviewerSideBar/reviewerSidebar";
import { Toaster } from "react-hot-toast";
import { Outlet } from "react-router-dom";
import "./leadReviewerLayout.css";

function LeadReviewerLayout() {
  return (
    <div className="layout-container">
      <Toaster />
      <Ribbon />
      <div className="ld-pages-container">
        <ReviewerSidebar />
        <main>
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default LeadReviewerLayout;
